import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { MapDevicesPayload } from '../../pages/equipment/devices/components/devices.models';
import { MapCoordinates } from 'src/app/pages/help-and-settings/user-settings/api/user-settings-api.type';

@Injectable({
  providedIn: 'root'
})
export class MapApiService {
  private http = inject(HttpClient);

  getDevicesFocusArea(payload: MapDevicesPayload): Observable<MapCoordinates> {
    return this.http.post<MapCoordinates>('api/map/focus-area/devices', payload);
  }

  getAlarmsFocusArea(payload: MapDevicesPayload): Observable<MapCoordinates> {
    return this.http.post<MapCoordinates>('api/map/focus-area/alarms', payload);
  }

  getEventsFocusArea(payload: MapDevicesPayload): Observable<MapCoordinates> {
    return this.http.post<MapCoordinates>('api/map/focus-area/events', payload);
  }
}
